export const formConfig = [
  {
    name: 'number_of_musical_instruments_played',
    question: 'How many musical instruments do you play?',
    type: 'slider',
    range: [0, 4, 1],
    value: 2,
    //Slider: 0-4+
  },

  {
    name: 'number_of_languages_spoken',
    question: 'How many languages do you speak conversationally?',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //Scale from 1-5
  },

  {
    name: 'hand_used_for_writing',
    question: 'Which hand hand do you write with?',
    type: 'radio',
    choices: ['Left', 'Right', 'Both'],
    value: null,
    //[Radio button] Left, Right, Both
  },

  {
    name: 'pet_preference',
    question: 'Do you prefer cats or dogs?',
    type: 'radio',
    choices: ['Dogs', 'Cats', 'Both', 'Neither'],
    value: null,
    //[Radio button] Dogs, Cats, Both, Neither
  },

  {
    name: 'hand_used_for_throwing',
    question: 'Which hand do you throw with?',
    type: 'radio',
    choices: ['Left', 'Right', 'Both'],
    value: null,
    //[Radio button] Left, Right, Both
  },

  {
    name: 'enjoys_drawing',
    question: 'How much do you enjoy drawing?',
    type: 'radio',
    choices: [1, 2, 3, 4, 5],
    choicesText: ['It’s the worst', 'Not my thing', 'Neutral', 'I like it', 'It’s the best'],
    value: null,
    //[Radio button] 1 (It’s the worst), 2 (Not my favorite), 3 (Neutral), 4 (I like it), 5 (It’s the best)o
  },

  {
    name: 'enjoys_math',
    question: 'How much do you enjoy math?',
    type: 'radio',
    choices: [1, 2, 3, 4, 5],
    choicesText: ['It’s the worst', 'Not my thing', 'Neutral', 'I like it', 'It’s the best'],
    value: null,
    //[Radio button] 1 (It’s the worst), 2 (Not my favorite), 3 (Neutral), 4 (I like it), 5 (It’s the best)
  },

  {
    name: 'left_or_right_handed',
    question: 'Are you naturally right- or left-handed?',
    type: 'radio',
    choices: ['Left', 'Right', 'Either'],
    value: null,
    //[Radio button] Left, Right, Either
  },

  {
    name: 'hours_slept_actual',
    question: 'How many hours a night do you sleep on average?',
    type: 'slider',
    range: [3, 12, 1],
    value: 8,
    //Scale from 3-12
  },

  {
    name: 'hours_slept_preferable',
    question: 'How many hours do you wish you slept each night?',
    type: 'slider',
    range: [3, 12, 1],
    value: 8,
    //Scale from 3-12
  },

  {
    name: 'resting_heart_rate',
    question: 'What’s your resting heart rate?',
    type: 'slider',
    range: [40, 110, 5],
    value: 75,
    //Scale from 40-110+ (5 point increments)
  },

  {
    name: 'number_of_cavities',
    question: 'Approximately many cavities have you had?',
    type: 'slider',
    range: [0, 15, 1],
    value: 0,
    //Scale from 0-15+
  },

  {
    name: 'days_for_excercise_per_week',
    question: 'How many days per week do you exercise for 30+ minutes?',
    type: 'slider',
    range: [0, 7, 1],
    value: 0,
    //Scale from 0-7
  },

  {
    name: 'number_of_alcolic_drinks_per_week',
    question: 'How many alcoholic drinks do you have per week?',
    type: 'slider',
    range: [0, 30, 1],
    value: 0,
    //Scale from 0-30+
  },

  {
    name: 'days_using_cannabis_per_week',
    question: 'How many days per week do you use cannabis products?',
    type: 'slider',
    range: [0, 7, 1],
    value: 0,
    //Scale from 0-7
  },

  {
    name: 'cigarettes_smoking_frequency',
    question: 'How often do you smoke cigarettes?',
    type: 'radio',
    choices: ['Daily', 'Weekly', 'Monthly', 'Every few months', 'Yearly', 'Never'],
    value: null,
    //[radio button] Daily, Weekly, Monthly, A few times per year, Yearly, Never
  },

  {
    name: 'nicotine_vaporizer_frequency',
    question: 'How often do you use a nicotine vaporizer?',
    type: 'radio',
    choices: ['Daily', 'Weekly', 'Monthly', 'Every few months', 'Yearly', 'Never'],
    value: null,
    //[radio button] Daily, Weekly, Monthly, A few times per year, Yearly, Never
  },

  {
    name: 'experienced_headaches_migranes',
    question: 'Have you ever had moderate to severe headaches or migraines?',
    type: 'radio',
    choices: ['Yes', 'No', 'Not sure'],
    value: null,
    //[radio button] Yes, No, Not sure
  },

  {
    name: 'familly_experienced_headaches_migranes',
    question: 'Has anyone in your family ever had moderate to severe headaches or migraines?',
    type: 'radio',
    choices: ['Yes', 'No', 'Not sure'],
    value: null,
    //[radio button] Yes, No, Not sure
  },

  {
    name: 'diagnosed_with',
    question: 'Have you ever been diagnosed with any of the following?',
    type: 'checkbox',
    choices: ['ADHD/ADD', 'Autism Spectrum Disorder', 'Epilepsy', 'Multiple Sclerosis', 'OCD', 'Parkinson’s', 'Schizophrenia', 'None'],
    value: null,
    //[Checkboxes] ADHD/ADD, Autism Spectrum Disorder, Epilepsy, Multiple Sclerosis, OCD, Parkinson’s, Schizophrenia, None
  },

  {
    name: 'familly_diagnosed_with',
    question: 'Has anyone in your family ever been diagnosed with any of the following?',
    type: 'checkbox',
    choices: ['ADHD/ADD', 'Autism Spectrum Disorder', 'Epilepsy', 'Multiple Sclerosis', 'OCD', 'Parkinson’s', 'Schizophrenia', 'None'],
    value: null,
    //[Checkboxes] ADHD/ADD, Autism Spectrum Disorder, Epilepsy, Multiple Sclerosis, OCD, Parkinson’s, Schizophrenia, None
  },

  {
    name: 'number_of_allergies',
    question: 'How many allergies do you have?',
    type: 'slider',
    range: [0, 10, 1],
    value: 0,
    //0 - 10+ slider
  },

  {
    name: 'scale_recommend_brainkey',
    question: 'On a scale of 0-10 how likely are you to recommend BrainKey to a friend?',
    type: 'slider',
    range: [0, 10, 1],
    value: 5,
    //[Scale from 0-10]
  },

  {
    name: 'scale_interest_brain_volume',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'Measure the volume of your brain or its components',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] ] Measure the volume of your brain or its components
  },

  {
    name: 'scale_interest_brain_types',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'See various brain types (e.g. child, person with Alzheimer’s)',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] See various brain types (e.g. child, person with Alzheimer's)
  },

  {
    name: 'scale_interest_compare_human_animal_brain',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'See human brains compared to animals',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] See human brains compared to animals
  },

  {
    name: 'scale_interest_barin_part_activity',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'See what parts of the brain perform various activities (e.g. sleep, movement, fear)',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] See what parts of the brain perform various activities (e.g. sleep, movement, fear)
  },

  {
    name: 'scale_interest_compare_own_other_brain',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'Compare your brain to another person’s',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] Compare your brain to another person’s
  },

  {
    name: 'scale_interest_draw_custom_region',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'Draw or annotate a custom region for a future reference',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] Draw or annotate a custom region for future reference
  },

  {
    name: 'scale_interest_discuss_with_specialist',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'Discuss your brain with a doctor or neuroscientist',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] Discuss your brain with a doctor or neuroscientist
  },

  {
    name: 'scale_interest_brain_changes_over_time',
    question: 'On a scale of 1 (not interested) to 5 (extremely interested), please rate your interest in the following feature:',
    subquestion: 'See changes in your brain over time using two or more brain scans',
    type: 'slider',
    range: [1, 5, 1],
    value: 3,
    //[Scale from 1-5] See changes in your brain over time using two or more brain scans
  },

  {
    name: 'interest_in_disorders',
    question: 'Check the box for each disorder you’d like to visualize and learn more about',
    type: 'checkbox',
    choices: ['Bipolar disorder', 'Dementia', 'Hydrocephalus', 'PTSD', 'Retrograde amnesia', 'Schizophrenia'],
    value: null,
    //[checkboxes] Bipolar disorder, Dementia, Hydrocephalus, PTSD, Retrograde amnesia, Schizophrenia
  },
];
